export function replaseStr(str, data, prefix = '{{', suffix = '}}', def = "") {
  let newStr = str;
  try {
    function humpFormatChange(str) {
      let lastIte = '';
      let arr = str.split('');
      let newArr = arr.map((ite, idx) => {
        let regexp = /^[a-zA-Z]+$/
        if (ite.match(regexp)) {
          if (lastIte.toUpperCase() !== lastIte && ite.toUpperCase() === ite) {
            lastIte = ite;
            return ' ' + ite;
          }
        }
        lastIte = ite;
        return ite;
      })
      return newArr.join('');
    }
    Object.keys(data).forEach(key => {
      newStr = newStr.replace(RegExp(`${prefix}${key}${suffix}`, "g"), data[key] || def)
        .replace(RegExp(`${prefix}${humpFormatChange(key)}${suffix}`, "g"), data[key] || def)
    })
  } catch (error) {
  }
  return newStr
}

export function markdownItSplit(content, prefix, suffix) {
  if (prefix == suffix) {
    function splitNode(texts) {
      let nodes = [];
      if (texts.length > 2) {
        if (texts[0]) {
          nodes.push({ type: 'text', value: texts[0] });
        }
        if (texts[1]) {
          nodes.push({ type: 'match', value: texts[1] });
        }
        nodes.push(...splitNode(texts.slice(2)));
      } else {
        nodes.push({ type: 'text', value: texts.join(prefix) });
      }
      return nodes;
    }
    var texts = `${content}`.split(prefix);
    if (texts.length > 2) {
      return splitNode(texts);
    }
    return [{ type: 'text', value: content }];
  } else {
    var texts = `${content}`.split(prefix);
    if (texts.length > 1) {
      let nodes = [];
      for (let i = 0; i < texts.length; i++) {
        if (texts[i]) {
          if (i == 0) {
            nodes.push({ type: 'text', value: texts[i] });
          } else {
            let values = `${texts[i]}`.split(suffix);
            if (values.length > 1) {
              nodes.push({ type: 'match', value: values[0] });
              nodes.push({ type: 'text', value: values.slice(1).join(suffix) });
            } else {
              nodes.push({ type: 'text', value: `${prefix}${texts[i]}` });
            }
          }
        }
      }
      return nodes;
    }
    return [{ type: 'text', value: content }];
  }
}


export function markdownItLinkPlugin(md, options = {}) {
  const { pluginName, replaceLink } = options;
  md.core.ruler.after('inline', pluginName, (state) => {
    var j, l, blockTokens = state.tokens;
    for (j = 0, l = blockTokens.length; j < l; j++) {
      if (blockTokens[j].type !== 'inline') { continue; }
      (blockTokens[j].children || []).forEach(token => {
        // 改写链接的href属性
        if (typeof replaceLink === 'function' && token.type == 'link_open') {
          (token.attrs || []).forEach(attr => {
            if (attr[0] === 'href') {
              attr[1] = replaceLink(attr[1]);
            }
          })
        }
      });
    }
  });
}

export function markdownItReplacePlugin(md, options = {}) {
  const { pluginName, replaceToken, replaceAttrs } = options;
  md.core.ruler.after('inline', pluginName, (state) => {
    var i, j, l, tokens, token,
      blockTokens = state.tokens;
    for (j = 0, l = blockTokens.length; j < l; j++) {
      if (blockTokens[j].type !== 'inline') { continue; }
      tokens = blockTokens[j].children;
      // 切割和替换Token
      let splitedTokens = [];
      for (let i = 0; i < tokens.length; i++) {
        token = tokens[i];
        if (token) {
          if (token.type === 'text') {
            splitedTokens.push(...replaceToken(token.content, state.Token));
          } else {
            splitedTokens.push(token);
          }
        }
      }
      // 替换Attrs属性
      splitedTokens.forEach(token => {
        if (typeof replaceAttrs === 'function') {
          token.attrs = replaceAttrs(token.attrs);
        }
      });
      // 合并Token内容
      let margeTokens = [];
      splitedTokens.forEach(token => {
        if (token.type === 'text') {
          let lastToken = margeTokens.length > 0 ? margeTokens[margeTokens.length - 1] : null;
          if (lastToken && lastToken.type === 'text') {
            lastToken.content = `${lastToken.content}${token.content}`
          } else {
            margeTokens.push(token);
          }
        } else {
          margeTokens.push(token);
        }
      });
      // 改写元素内容
      if (margeTokens.length > 0) {
        blockTokens[j].children = margeTokens;
      }
    }
  });
}
